import dynamic from 'next/dynamic';
import Loading from '@/components/Loading';
import { LAYOUT } from '@/constants/config';

const PMSIntro = dynamic(() => import('@/components/PMS/PMSIntro'), {
  ssr: false,
  loading: () => <Loading />,
});
const DataAnalytics = dynamic(() => import('@/components/PMS/DataAnalytics'), {
  ssr: false,
  loading: () => <Loading />,
});
const DiCloudReport = dynamic(() => import('@/components/PMS/DiCloudReport'), {
  ssr: false,
  loading: () => <Loading />,
});
const UseCases = dynamic(() => import('@/components/PMS/UseCases'), {
  ssr: false,
  loading: () => <Loading />,
});
const FreeTrialBanner = dynamic(
  () => import('@/components/PMS/FreeTrialBanner'),
  {
    ssr: false,
    loading: () => <Loading />,
  }
);
export default function PMSPage() {
  return (
    <article className="pms">
      <PMSIntro />
      <DataAnalytics />
      <DiCloudReport />
      <UseCases />
      <FreeTrialBanner />
    </article>
  );
}

PMSPage.layout = LAYOUT.HEADER_NORMAL;
PMSPage.title = 'common.meta.page.pms';
